import { isToday, parseISO } from 'date-fns';

import Button from '@/components/ui/buttons/Button';
import Modal from '@/components/ui/modals/Modal';
import { type ModalInnerProps } from '@/hooks/common/useModal';

import styles from './AbsencesTimeExceededModal.module.scss';

interface Props extends ModalInnerProps {
  timeLimit?: string | null;
  postDate?: string;
}

const AbsencesTimeExceededModal: React.FC<Props> = ({
  isOpen,
  toggle,
  timeLimit = '08:30',
  postDate,
}) => {
  let isPostedToday = true;
  if (postDate && typeof postDate === 'string') {
    isPostedToday = isToday(parseISO(postDate));
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} title={'欠席連絡を変更できません'}>
      <div className={styles.description}>
        {isPostedToday ? (
          <>
            当日の欠席連絡の変更は{timeLimit}までです。
            <br />
            {timeLimit}以降は直接学校に問い合わせてください。
          </>
        ) : (
          <>欠席連絡は当日以降の連絡のみ可能です。</>
        )}
      </div>
      <div className={styles.buttons}>
        <Button
          size="s"
          color="outline"
          onClick={toggle}
          className={styles.button}
        >
          閉じる
        </Button>
      </div>
    </Modal>
  );
};

export default AbsencesTimeExceededModal;
